import React, { useEffect, useState } from 'react';
// Components
import BookingAdminPageMainContainer from '../../../components/booking/admin/BookingAdminPageMainContainer';
import Navbar from '../../../components/nav/Navbar';
import PageDivider from '../../../components/gallery/PageDivider';
import GeneralHeader from '../../../components/header/GeneralHeader';
import { HelmetItem } from '../../../components/utils/HelmetItem';
import { CompanyName } from '../../../utils/Constants';

function BookingAdminPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-booking-admin');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <HelmetItem
        PageName='Booking Admin'
        desc={`${CompanyName} — book commercials, UGC creation, or wellness coaching. Secure your spot today and get the help you need, tailored to your goals.`}
        keywords={`booking, schedule, commercials, UGC creator, wellness coaching, ${CompanyName}, Drammen Norway, worldwide`}
        additionalMeta={[]}
        structuredData={[]}
      />
      {/* Page */}
      <div className='grid grid-rows-reg min-h-screen font-main bg-colour1 dark:bg-colour1 text-colour2 dark:text-colour2 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-booking-admin'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`Booking Admin`}
            title={`Your Booking Information`}
          />
        </div>

        {/* Main */}
        <BookingAdminPageMainContainer />
      </div>
    </>
  );
}

export default BookingAdminPage;
